export const PACKAGING_HISTORY_LIST_REQUEST = 'PACKAGING_HISTORY_LIST_REQUEST';
export const PACKAGING_HISTORY_LIST_SUCCESS = 'PACKAGING_HISTORY_LIST_SUCCESS';
export const PACKAGING_HISTORY_LIST_FAIL    = 'PACKAGING_HISTORY_LIST_FAIL';